// import client from './client'

// export const getUsers = () => client.get('/admin/users')
// export const updateUserRole = (id, role) => client.patch(`/admin/users/${id}/role`, { role })
// export const deleteUser = (id) => client.delete(`/admin/users/${id}`)
// export const getAnalytics = () => client.get('/admin/analytics')

// frontend/src/api/admin.js
import api from "./client";

// Get all users (or filter by role/search)
export const getUsers = (role = "", search = "") => {
  const params = new URLSearchParams();
  if (role) params.append("role", role);
  if (search) params.append("search", search);
  
  const queryString = params.toString() ? `?${params.toString()}` : "";
  return api.get(`/admin/users${queryString}`);
};

// Update a user's role and currently am not using it
export const updateUserRole = (id, role) => {
  return api.patch(`/admin/users/${id}/role`, { role });
};

// Delete a user
export const deleteUser = (id) => {
  return api.delete(`/admin/users/${id}`);
};

export const banUser = (id) => {
  return api.patch(`/admin/users/${id}/ban`);
};

export const unbanUser = (id) => {
  return api.patch(`/admin/users/${id}/unban`);
};

export const createJob = (data) => {
  return api.post("/admin/jobs", data);
};

export const resetUserPassword = (userId, password) => {
  return api.post(`/admin/users/${userId}/reset-password`, { password });
};

export const deleteJob = (jobId) => {
  return api.delete(`/admin/jobs/${jobId}`);
};